import { ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="mx-auto w-full max-w-screen-2xl px-8 bg-white dark:bg-gray-900">
      <div className="flex flex-col min-h-svh pt-10">
        {children}
      </div>
    </div>
  );
}
